<div class="dialog customer-management-filter-dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">表示条件</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__body customer-management-filter-dialog__body">

    <!-- 稼働件数 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">稼働件数</div>
      <div class="customer-management-filter-dialog__range">
        <input
          type="number"
          [(ngModel)]="filterDraft.activeCountMin"
          placeholder="最小"
          class="customer-management-filter-dialog__range-input"
        />
        <span>〜</span>
        <input
          type="number"
          [(ngModel)]="filterDraft.activeCountMax"
          placeholder="最大"
          class="customer-management-filter-dialog__range-input"
        />
      </div>
    </div>

    <!-- 進捗件数 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">進捗件数</div>
      <div class="customer-management-filter-dialog__range">
        <input
          type="number"
          [(ngModel)]="filterDraft.progressCountMin"
          placeholder="最小"
          class="customer-management-filter-dialog__range-input"
        />
        <span>〜</span>
        <input
          type="number"
          [(ngModel)]="filterDraft.progressCountMax"
          placeholder="最大"
          class="customer-management-filter-dialog__range-input"
        />
      </div>
    </div>

    <!-- 稼働件数前日比 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">稼働件数前日比</div>
      <div class="customer-management-filter-dialog__range">
        <input
          type="number"
          [(ngModel)]="filterDraft.activeDayChangeMin"
          placeholder="最小"
          class="customer-management-filter-dialog__range-input"
        />
        <span>〜</span>
        <input
          type="number"
          [(ngModel)]="filterDraft.activeDayChangeMax"
          placeholder="最大"
          class="customer-management-filter-dialog__range-input"
        />
      </div>
    </div>

    <!-- 進捗件数前日比 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">進捗件数前日比</div>
      <div class="customer-management-filter-dialog__range">
        <input
          type="number"
          [(ngModel)]="filterDraft.progressDayChangeMin"
          placeholder="最小"
          class="customer-management-filter-dialog__range-input"
        />
        <span>〜</span>
        <input
          type="number"
          [(ngModel)]="filterDraft.progressDayChangeMax"
          placeholder="最大"
          class="customer-management-filter-dialog__range-input"
        />
      </div>
    </div>

    <!-- 求職者名 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">求職者名</div>
      <input
        type="text"
        [(ngModel)]="filterDraft.studentName"
        placeholder="氏名を入力"
        class="customer-management-filter-dialog__text-input"
      />
    </div>

    <!-- 卒業年 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">卒業年</div>
      <ag-select
        [options]="graduateYearOptions"
        [placeholder]="'選択してください'"
        [multi]="true"
        [(ngModel)]="filterDraft.graduateYears"
        [extraClass]="'select-btn--no-dim'"
      ></ag-select>
    </div>

    <!-- 文理 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">文理</div>
      <select class="select select--bg-gray select--small" [(ngModel)]="filterDraft.academicFieldType">
        <option [ngValue]="null">選択してください</option>
        <option *ngFor="let type of ACADEMIC_FIELD_TYPES" [ngValue]="type">{{ type }}</option>
      </select>
    </div>

    <!-- 大学グループ -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">大学グループ</div>
      <div class="customer-management-filter-dialog__checkboxes">
        <label *ngFor="let level of UNIVERSITY_LEVELS" class="customer-management-filter-dialog__checkbox-item">
          <input
            type="checkbox"
            [checked]="isInFilter(filterDraft.universityLevels, level)"
            (change)="filterDraft.universityLevels = toggleInFilter(filterDraft.universityLevels, level)"
          />
          {{ level }}
        </label>
      </div>
    </div>

    <!-- カウンセリング日 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">カウンセリング日</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.interviewDateFrom"
            (change)="clearPeriod('interviewDate')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.interviewDateTo"
            (change)="clearPeriod('interviewDate')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.interviewDatePeriod === p.key"
            (click)="setDatePeriod('interviewDate', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('interviewDate', false)"
              (click)="toggleOtherDropdown('interviewDate', $event)"
            >{{ getOtherPeriodLabel('interviewDate', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['interviewDate']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.interviewDatePeriod === p.key"
                (click)="selectOtherPeriod('interviewDate', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SF -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">SF</div>
      <div class="customer-management-filter-dialog__checkboxes">
        <label *ngFor="let rank of SF_RANKS" class="customer-management-filter-dialog__checkbox-item">
          <input
            type="checkbox"
            [checked]="isInFilter(filterDraft.sfRanks, rank)"
            (change)="filterDraft.sfRanks = toggleInFilter(filterDraft.sfRanks, rank)"
          />
          {{ rank }}
        </label>
      </div>
    </div>

    <!-- ご支援想定企業名 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">ご支援想定企業名</div>
      <input
        type="text"
        [(ngModel)]="filterDraft.enterpriseName"
        placeholder="企業名を入力"
        class="customer-management-filter-dialog__text-input"
      />
    </div>

    <!-- ご支援想定企業名選考日程 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">ご支援想定企業名選考日程</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.expectedCompanySeminarDateFrom"
            (change)="clearPeriod('expectedCompanySeminarDate')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.expectedCompanySeminarDateTo"
            (change)="clearPeriod('expectedCompanySeminarDate')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.expectedCompanySeminarDatePeriod === p.key"
            (click)="setDatePeriod('expectedCompanySeminarDate', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('expectedCompanySeminarDate', false)"
              (click)="toggleOtherDropdown('expectedCompanySeminarDate', $event)"
            >{{ getOtherPeriodLabel('expectedCompanySeminarDate', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['expectedCompanySeminarDate']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.expectedCompanySeminarDatePeriod === p.key"
                (click)="selectOtherPeriod('expectedCompanySeminarDate', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 計上月 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">計上月</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="month"
            min="1900-01"
            max="2500-01"
            [(ngModel)]="filterDraft.expectedContractMonthFrom"
            (change)="clearPeriod('expectedContractMonth')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="month"
            min="1900-01"
            max="2500-01"
            [(ngModel)]="filterDraft.expectedContractMonthTo"
            (change)="clearPeriod('expectedContractMonth')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of MONTH_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.expectedContractMonthPeriod === p.key"
            (click)="setMonthPeriod('expectedContractMonth', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('expectedContractMonth', true)"
              (click)="toggleOtherDropdown('expectedContractMonth', $event)"
            >{{ getOtherPeriodLabel('expectedContractMonth', true) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['expectedContractMonth']">
              <button
                *ngFor="let p of MONTH_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.expectedContractMonthPeriod === p.key"
                (click)="selectOtherPeriod('expectedContractMonth', p.key, true)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- コンタクト -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">コンタクト</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.contactDateFrom"
            (change)="clearPeriod('contactDate')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.contactDateTo"
            (change)="clearPeriod('contactDate')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.contactDatePeriod === p.key"
            (click)="setDatePeriod('contactDate', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('contactDate', false)"
              (click)="toggleOtherDropdown('contactDate', $event)"
            >{{ getOtherPeriodLabel('contactDate', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['contactDate']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.contactDatePeriod === p.key"
                (click)="selectOtherPeriod('contactDate', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- セカマ -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">セカマ</div>
      <select class="select select--bg-gray select--small" [(ngModel)]="filterDraft.is2ndMatchValue">
        <option [ngValue]="null">選択してください</option>
        <option *ngFor="let v of IS2ND_MATCH_VALUES" [ngValue]="v">{{ v }}</option>
      </select>
    </div>

    <!-- 最終求人紹介 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">最終求人紹介</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.check5IntroduceFrom"
            (change)="clearPeriod('check5Introduce')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.check5IntroduceTo"
            (change)="clearPeriod('check5Introduce')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.check5IntroducePeriod === p.key"
            (click)="setDatePeriod('check5Introduce', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('check5Introduce', false)"
              (click)="toggleOtherDropdown('check5Introduce', $event)"
            >{{ getOtherPeriodLabel('check5Introduce', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['check5Introduce']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.check5IntroducePeriod === p.key"
                (click)="selectOtherPeriod('check5Introduce', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 最終応募 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">最終応募</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.check5ApplyFrom"
            (change)="clearPeriod('check5Apply')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.check5ApplyTo"
            (change)="clearPeriod('check5Apply')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.check5ApplyPeriod === p.key"
            (click)="setDatePeriod('check5Apply', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('check5Apply', false)"
              (click)="toggleOtherDropdown('check5Apply', $event)"
            >{{ getOtherPeriodLabel('check5Apply', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['check5Apply']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.check5ApplyPeriod === p.key"
                (click)="selectOtherPeriod('check5Apply', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ログイン日 -->
    <div class="customer-management-filter-dialog__row customer-management-filter-dialog__row--date">
      <div class="customer-management-filter-dialog__label">ログイン日</div>
      <div class="customer-management-filter-dialog__date-field">
        <div class="customer-management-filter-dialog__range">
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.mypageLoggedInAtFrom"
            (change)="clearPeriod('mypageLoggedInAt')"
            class="customer-management-filter-dialog__range-input"
          />
          <span>〜</span>
          <input
            type="date"
            min="1900-01-01"
            max="2500-01-01"
            [(ngModel)]="filterDraft.mypageLoggedInAtTo"
            (change)="clearPeriod('mypageLoggedInAt')"
            class="customer-management-filter-dialog__range-input"
          />
        </div>
        <div class="date-period-buttons">
          <button
            *ngFor="let p of DATE_RANGE_PERIODS"
            class="date-period-btn"
            [class.date-period-btn--active]="filterDraft.mypageLoggedInAtPeriod === p.key"
            (click)="setDatePeriod('mypageLoggedInAt', p.key)"
          >{{ p.label }}</button>
          <div class="date-period-other-container">
            <button
              class="date-period-btn date-period-btn--other"
              [class.date-period-btn--active]="isOtherPeriodSelected('mypageLoggedInAt', false)"
              (click)="toggleOtherDropdown('mypageLoggedInAt', $event)"
            >{{ getOtherPeriodLabel('mypageLoggedInAt', false) }}<span class="date-period-arrow date-period-arrow--down"></span></button>
            <div class="date-period-other__dropdown" *ngIf="otherDropdownOpen['mypageLoggedInAt']">
              <button
                *ngFor="let p of DATE_OTHER_PERIODS"
                class="date-period-other__option"
                [class.date-period-other__option--active]="filterDraft.mypageLoggedInAtPeriod === p.key"
                (click)="selectOtherPeriod('mypageLoggedInAt', p.key, false)"
              >{{ p.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 書類回収状況 -->
    <div class="customer-management-filter-dialog__row">
      <div class="customer-management-filter-dialog__label">書類回収状況</div>
      <select class="select select--bg-gray select--small" [(ngModel)]="filterDraft.documentStatus">
        <option [ngValue]="null">選択してください</option>
        <option *ngFor="let status of DOCUMENT_STATUSES" [ngValue]="status">{{ status }}</option>
      </select>
    </div>

    <!-- 求職者担当（マネージャーのみ） -->
    <div class="customer-management-filter-dialog__row" *ngIf="isMgrMode">
      <div class="customer-management-filter-dialog__label">求職者担当</div>
      <div class="customer-management-filter-dialog__checkboxes">
        <label *ngFor="let user of caUserList" class="customer-management-filter-dialog__checkbox-item">
          <input
            type="checkbox"
            [checked]="isInFilter(filterDraft.caUserIds, user.id)"
            (change)="filterDraft.caUserIds = toggleInFilter(filterDraft.caUserIds, user.id)"
          />
          {{ user.name }}
        </label>
      </div>
    </div>

  </div>

  <div class="dialog__footer customer-management-filter-dialog__footer">
    <button class="btn btn--small btn--green" (click)="saveFilter()">保存</button>
    <button class="btn btn--small btn--blue" (click)="clearFilter()">クリア</button>
    <button class="btn btn--small btn--blue" (click)="applyFilter()">適用</button>
  </div>
</div>
